<script lang="ts" setup>
import { computed } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import TableWithStickyHeader, {
  TableColumn,
} from '@/components/common/TableWithStickyHeader.vue'
import i18n from '@/i18n'
import { useAveragesStore } from '@/store/public/averages'
import { formatFloat, formatValue } from '@/utils/format'

const averages = useAveragesStore()

const tableColumns = computed<TableColumn[]>((): TableColumn[] => [
  { label: i18n.global.t('averages.name'), type: 'any' },
  { label: i18n.global.t('averages.club'), type: 'any' },
  { label: i18n.global.t('averages.klass'), type: 'value' },
  { label: i18n.global.t('averages.average'), type: 'value' },
  { label: i18n.global.t('averages.basis'), type: 'value-wide' },
  { label: i18n.global.t('averages.previous'), type: 'value-wide' },
  { label: i18n.global.t('averages.cut-score-games'), type: 'value-wide' },
  { label: i18n.global.t('averages.season-games'), type: 'value-wide' },
  { label: i18n.global.t('averages.age-group'), type: 'value' },
])

const tableData = computed<string[][]>((): string[][] =>
  (averages.results ?? []).map((result) => [
    formatValue(result.bowler.full_name),
    formatValue(result.bowler.club),
    formatValue(result.bowler.klass),
    formatFloat(result.values.current_average, 2),
    formatFloat(result.values.average_basis, 0),
    formatFloat(result.values.previous_average, 2),
    formatFloat(result.values.season_cut_score_game_count, 0),
    formatFloat(result.values.season_game_count, 0),
    formatValue(result.bowler.age_group),
  ]),
)
</script>

<template>
  <NotificationBanner
    v-if="averages.results?.length === 0"
    :message="$t('averages.no-results')"
  />

  <TableWithStickyHeader
    v-if="averages.results?.length > 0"
    :columns="tableColumns"
    :data="tableData"
  />
</template>
